export interface SignedS3Response {
	name: string;
	dateCreated: number;
}

export interface UploadedFile extends File {
	dateCreated: number;
}

// dateCreated are strings @runtime (preserve interface)
export interface AttachedFile {
	path: string;
	dateCreated: number | string;
	key?: string;
	props?: { [key: string]: string };
	isLoading?: boolean;
}

export interface SignedUrl {
	file: string;
	dateCreated: number;
	url: string;
	uploadId: string;
}
export interface SimpleS3Object {
	key: string;
}

export interface DownloadResponse {
	location: string;
	headers: { [key: string]: string };
}

export interface FetchParams {
	url: string;
	params?: { [x: string]: string | number | boolean };
	token?: string;
	method?: string;
	body?: RequestBody;
	injectTenantId?: boolean;
}

export type RequestBody =
	| string
	| Blob
	| ArrayBufferView<ArrayBuffer>
	| ArrayBuffer
	| FormData
	| URLSearchParams
	| ReadableStream<Uint8Array>
	| null
	| undefined;
